import { useDispatch, useSelector } from 'react-redux';
import BaseSelect from 'lib/BaseSelect';
import { CodeNameModel, CreativeType } from 'components/common/types';
import { changeDealCurrentLineData } from 'store/dealManagement/reducer';
import { CREATIVE_TYPE_OPTIONS } from 'consts/creative';
import { Line } from 'components/common/types/Deal.types';
import { Store } from 'components/common/types/Store.types';
import { getIsNewLine } from 'store/dealManagement/selectors';
import { findOption } from 'lib/BaseSelect/utils';

const SelectCreativeType: React.FC = () => {
  const dispatch = useDispatch();

  const creativeType = useSelector((state: Store) => state.dealManagement.commonDeal.currentLine.creativeType);
  const isNewLine = useSelector(getIsNewLine);

  const selectCreativeValue = (): CodeNameModel => {
    if (!isNewLine && !creativeType) {
      dispatch(
        changeDealCurrentLineData({
          creativeType: CreativeType.VIDEO,
        }),
      );
      return findOption(CREATIVE_TYPE_OPTIONS, 'code', CreativeType.VIDEO) as CodeNameModel;
    }
    return findOption(CREATIVE_TYPE_OPTIONS, 'code', creativeType || undefined) as CodeNameModel;
  };

  return (
    <BaseSelect
      name="creativeType"
      dataTestId="creative-type-dropdown"
      options={CREATIVE_TYPE_OPTIONS}
      onSelect={(_, selectedCreativeTypeOption: CodeNameModel) => {
        dispatch(
          changeDealCurrentLineData({
            creativeType: selectedCreativeTypeOption?.code as Line['creativeType'],
          }),
        );
      }}
      placeholder="Select creative type"
      isDisabled={!isNewLine}
      isClearable
      selectedValue={selectCreativeValue()}
    />
  );
};

export default SelectCreativeType;
